import lottie from 'lottie-web'
import animationData from '../../lottie/hero-swoosh.json'

export default {
  animate (element) {
    const container = element.querySelector('.js-hero__lottie')
    const content  = element.querySelector('.js-hero__content')
      
    const animation = lottie.loadAnimation({
      container,
      renderer: 'svg',
      loop: false,
      autoplay: true,
      animationData,
      rendererSettings: { 
        preserveAspectRatio:'none',
      },
    })

    animation.addEventListener('complete', () => {
      content.classList.add('hero__content--animate')
    })

    window.addEventListener('scroll', () => {
      const parallax = 50 - Math.abs(window.pageYOffset / 20)
      element.style.backgroundPosition = `50% ${parallax}%`
    })
  },
  initHero(element) {
    element.addEventListener('lazyloaded', () => {
      this.animate(element)
    })
  },
  init () {
    const elements = document.querySelectorAll('.js-hero')
    if(!elements.length) return

    elements.forEach(element => { this.initHero(element)})
  },
} 